<template>
    <div class="row justify-content-center">
        <div class="col-lg-6 card-wrapper metadata">

            <card>
                <!-- Card header -->



                <div class="card-body">
                    <!-- Card body -->
                    <div class="row align-items-center blurb">

                        

                    <div class="col-md-12">
                    <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
                        <form class="needs-validation" @submit.prevent="handleSubmit(firstFormSubmit)">
                            <!-- Input groups with icon -->

    <!-- div class="container p-5">
        <div class="row">
            <div class="col-md-3"></div>
            <div class="col-md-6 mt-5">
                <div class="bg-white p-5 rounded shadow-sm border">
                    <div class="dropzone d-block">
                        <label for="files" class="dropzone-container">
                            <div class="file-icon"><i class="fa-solid fa-file-circle-plus text-primary"></i></div>
                            <div class="text-center pt-3 px-5">
                                <p class="w-80 h5 text-dark fw-bold">Drag your documents, photos or videos here to start uploading.</p>
                                <div class="hr-sect">or</div>
                                <button class="btn btn-primary mb-2">Browse Files</button>
                            </div>
                        </label>
                        <input id="files" name="files[]" type="file" class="file-input" />
                    </div>
                </div>
            </div>
        </div>
    </div -->

    
                            <b-row >

                                <b-col md="8"><label>Please upload 3 images for the cover</label></b-col>
                                <b-col md="4" class="text-right">
                                    <span class="badge badge-info badge-circle text-white" @click="cover_art_hint()">
                                        <i class="fa fa-question"></i>
                                    </span>
                                </b-col>

                                <b-col md="12">
                                                     
                        
                                    <dropzone-file-upload v-model="inputs.fileMultiple" multiple
                                        :options="cover_art_dz.options"
                                        :url="cover_art_dz.url" 
                                        v-on:complete="co_dz_complete" 
                                        v-on:success="co_dz_success" 
                                        v-on:addedfile="co_dz_added" 
                                        v-on:error="co_dz_error" 
                                        v-on:queuecomplete="co_dz_queuecomplete"
                                    ></dropzone-file-upload>
                                        
                                </b-col>

                            </b-row>

                            <b-row >

<b-col md="12" v-if="currentPhotoBookImages.length < 3 && currentPhotoBookImages.length > 0">
    <h2 class="card-title">
                            Please upload {{ 3-currentPhotoBookImages.length }} more images for your cover
                        </h2>
    </b-col></b-row>
                            <b-row >

                                <b-col md="12">
                                    
                                    <b-list-group v-for="(image, index) in currentPhotoBookImages" v-bind:key="index" class="list-group dz-preview dz-preview-multiple list-group-lg list-group-flush">

                                        <dz-list-group-item :url="null" :img="image" :id="image.id" :num="index" @image_deleted="image_deleted"></dz-list-group-item>

                                    </b-list-group>

                                </b-col>

                            </b-row>

                            <b-row style="padding-top: 20px;">

                            

                                <b-col md="8"><label>Please provide a short design brief for the cover</label></b-col>
                                <b-col md="4" class="text-right">
                                    <span class="badge badge-info badge-circle text-white"  @click="design_description_hint()">
                                        <i class="fa fa-question"></i>
                                    </span>
                                </b-col>


                                <b-col md="12">
                                    
                                    <base-input>
                                        <textarea v-model="currentPhotoBook.design_keywords" placeholder="Design description for your designer" class="form-control" id="exampleFormControlTextarea1" rows="5"></textarea>
                                    </base-input>

                                </b-col>

                            </b-row>

                            <b-row>

                                <b-col md="12">
                                    
                                    <b-form-checkbox class="mb-3" v-model="upload_design_examples" checked="">
                                        I want to upload design examples which look appealing to me 
                                    </b-form-checkbox>

                                </b-col>

                            </b-row>


                            <b-row v-if="upload_design_examples">

                                <b-col md="12">
                                    <dropzone-file-upload v-model="inputs.fileMultiple" multiple 
                                        :options="design_example_dz.options"
                                        :url="design_example_dz.url" 
                                        v-on:complete="ex_dz_complete" 
                                        v-on:success="ex_dz_success" 
                                        v-on:addedfile="ex_dz_added" 
                                        v-on:error="ex_dz_error" 
                                        v-on:queuecomplete="ex_dz_queuecomplete"
                                    ></dropzone-file-upload>
                                        
                                </b-col>

                            </b-row>

                            <b-row v-if="upload_design_examples">

                                <b-col md="12">
                                    
                                    <b-list-group v-for="(image, index) in design_example_images" v-bind:key="index" class="list-group dz-preview dz-preview-multiple list-group-lg list-group-flush">

                                        <dz-list-group-item :url="null" :img="image" :id="image.id" :num="index"></dz-list-group-item>

                                    </b-list-group>

                                </b-col>

                            </b-row>
                            <!-- div class="btn-wrapper text-center">

                                <base-button type="primary" class="btn btn-danger" @click="onCancel">
                                    <span class="btn-inner--text">Back</span>
                                </base-button>

                                <base-button type="primary" class="btn btn-success" @click="onProceed"
                                    :disabled="mayProceed">
                                    <span class="btn-inner--text">Next</span>
                                </base-button>

                            </div -->

                        </form>
                    </validation-observer>
                </div>
                </div>
                </div>
            </card>
        </div>
    </div>
</template>
<script>
import { mapGetters, mapState, mapMutations, mapActions } from 'vuex'
import { Tooltip } from 'element-ui'
import DropzoneFileUpload from '@/components/Inputs/DropzoneFileUpload'
import DzListGroupItem from '../../../cscomponents/elements/DzListGroupItem';
import swal from 'sweetalert2';
import 'sweetalert2/dist/sweetalert2.css';

export default {
    name: 's03',
    components: {
        DropzoneFileUpload,
        DzListGroupItem,
        [Tooltip.name]: Tooltip
    },
    data() {
        return {
            cover_art_dz: {
                options: {
                    type: Object,
                    autoProcessQueue: true,
                    uploadMultiple: false,
                    parallelUploads: 1,
                    addRemoveLinks: false,
                    acceptedFiles: 'image/*',
                    maxFiles: 3,
                    maxFilesize: 1000,
                    disablePreviews: true,
                    timeout: 1800000,
                    paramName: "[photo_book][photo_book_images][temp_image]",
                    params: {
                        '[photo_book][photo_book_images][imagetype]': 'coverreq',
                    },
                    headers: {
                        "Authorization": 'Bearer ' + localStorage.token,
                    }
                },
                url: '',
            },
            design_example_dz: {
                options: {
                    type: Object,
                    autoProcessQueue: true,
                    uploadMultiple: false,
                    parallelUploads: 1,
                    addRemoveLinks: false,
                    acceptedFiles: 'image/*,application/pdf',
                    maxFiles: 4,
                    maxFilesize: 100000,
                    disablePreviews: true,
                    timeout: 1800000,
                    paramName: "[photo_book][photo_book_images][temp_image]",
                    params: {
                        '[photo_book][photo_book_images][imagetype]': 'design_example',
                    },
                    headers: {
                        "Authorization": 'Bearer ' + localStorage.token,
                    }
                },
                url: '',
            },
            ims: [],
            inputs: {
                fileSingle: [],
                fileMultiple: []
            },
            show_cover_art_dropzone: true,
            upload_design_examples: false,
            design_example_images: [],
        };
    },
    methods: {
        dzUrl(){
            return process.env.VUE_APP_API_HOST + '/api/v1/spa/photo_books/' + this.currentPhotoBook.id + '/photo_book_image';
        },
        buildUrl(image){
            console.log(image)
            let ht = this.$image_host+image.image.medium.url;
            return ht
        },
        co_dz_added(data){
            console.log("ADDED"+data);
        },
        // dropzone part
        co_dz_complete(data){
            this.allDataValidated();
        },
        co_dz_success(data){
            console.log(data.xhr.response);
            this.currentPhotoBookImages.push(JSON.parse(data.xhr.response));
            this.allDataValidated();
        },
        co_dz_error(data){
            swal.fire({
                title: 'Please check requirements:',
                text: this.build_error_text(data.xhr.response),
                timer: 5000,
                buttonsStyling: false,
                confirmButtonClass: 'btn btn-warning',
                icon: 'warning'
            });
            this.allDataValidated();
        },
        co_dz_queuecomplete(data){
            console.log("QUEUECOMPLETE");
            //console.log(data);
        },

        ex_dz_added(data){
            console.log("ADDED"+data);
        },
        // dropzone part
        ex_dz_complete(data){
            
        },
        ex_dz_success(data){
            console.log(data.xhr.response);
            this.design_example_images.push(JSON.parse(data.xhr.response));
        },
        ex_dz_error(data){
            swal.fire({
                title: 'Please check requirements:',
                text: this.build_error_text(data.xhr.response),
                timer: 5000,
                buttonsStyling: false,
                confirmButtonClass: 'btn btn-warning',
                icon: 'warning'
            });
        },
        ex_dz_queuecomplete(data){
            console.log("QUEUECOMPLETE");
            //console.log(data);
        },
        build_error_text(response){
            let msg = "";
            let err = JSON.parse(response);

            Object.keys(err.errors).forEach(function(x){
                msg += x+":"+err.errors[x];
            });
            console.log(msg);
            return err.message+"\n"+msg;
        },
        fetchDesignExampleImages(){
            this.loading = true;
            this.$api.getPhotoBookImages(this.currentPhotoBook.id, this.id, 'design_example').then((response) => {
                console.log("fetched design example pics");
                console.log(response);
                this.design_example_images = response.data.photo_book_images;
                console.log(this.design_example_images.length);
                if(this.design_example_images.length > 0){
                    this.upload_design_examples = true;
                }
            }).catch((e) => {
                console.log(e);
            }).finally(() => {
                this.loading = false;
            });
        },
        onCancel: function () { },
        onProceed: function () { },
        allDataValidated: function () {
            console.log("checking images count: "+this.currentPhotoBookImages.length);
            console.log("checking keywords: "+this.currentPhotoBook.design_keywords);
            if (
                this.currentPhotoBookImages.length == 3 && (this.currentPhotoBook.design_keywords != "" && typeof this.currentPhotoBook.design_keywords !== undefined )
            ) {
                console.log("VALID ENABLING NEXT");
                this.$emit('allowProceed');
                this.show_cover_art_dropzone = false;
                return true;
            }
            this.$emit('denyProceed');
            return false;
        },

        cover_art_hint(){  
            swal.fire({
                title: 'Your cover art',
                text: 'Please upload the images in 300dpi jpeg for your designer to create cover proposals for you.',
                icon: 'info',
                buttonsStyling: false,
                confirmButtonClass: 'btn btn-info'
            });
        },
        design_description_hint(){  
            swal.fire({
                title: 'Design',
                text: 'Please describe in a few words what kind of design you would like to have - as a help for your designer. We recommnd you to check our catalog and choose the covers you like, drop here links to or files from e.g. pinterest/behance.',
                icon: 'info',
                buttonsStyling: false,
                confirmButtonClass: 'btn btn-info'
            });
        },
        image_deleted(){
            this.$store.dispatch('fetchPhotoBookImages', { pbid: this.currentPhotoBook.id, imagetype: "coverreq" });
        },
    },
    computed: {
        ...mapGetters({
            currentAccount: 'currentAccount',
            currentPhotoBook: 'currentPhotoBook',
            currentPhotoBookImages: 'currentPhotoBookImages',
        }),
        mayProceed: function () {
            return !this.allDataValidated();
        },
    },
    watch: {
        currentPhotoBookImages(newValue, oldValue) {
            console.log('queryParameter currentPhotoBookImages changed from: ' + oldValue + ' -> ' + newValue);
            this.allDataValidated();
        },
        currentPhotoBook: {
            handler:function (newItem) {
                //console.log("DEEPWATCH");//this.doSomethingWith(newItem);
                //this.currentPhotoBook.keywords = this.currentPhotoBook.keywords.split(',');
                this.allDataValidated();
               
            },
            deep: true
        },
    },
    mounted() {
        this.$store.dispatch('fetchPhotoBookImages', { pbid: this.currentPhotoBook.id, imagetype: "coverreq" });
        this.fetchDesignExampleImages();
        this.cover_art_dz.url = this.dzUrl();
        this.design_example_dz.url = this.dzUrl();
        this.$emit('denyProceed');
    },
};
</script>
<style>
        .dropzone {
            border: dashed 1px #ddd !important ;
            background-color: #f2f6fc;
            border-radius: 15px;
            margin-top: 10px;
        }
    
        .dropzone .dropzone-container {
            padding: 2rem 0;
            width: 100%;
            height: 100%;
            position: relative;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            color: #8c96a8;
            z-index: 20;
        }
    
        .dropzone .file-input {
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            opacity: 0;
            visibility: hidden;
            cursor: pointer;
        }

        .file-icon{
            font-size: 60px;
        }
        .hr-sect {
            display: flex;
            flex-basis: 100%;
            align-items: center;
            margin: 8px 0px;
        }
        .hr-sect:before,
        .hr-sect:after {
            content: "";
            flex-grow: 1;
            background: #ddd;
            height: 1px;
            font-size: 0px;
            line-height: 0px;
            margin: 0px 8px;
        }
        .dz-button {
            color: #fff;
            background-color: #e62054;
            border-color: #e62054;
            -webkit-box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
            box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
            border-radius: 0.25rem;
            padding: 5px;
            font-family: inherit;
            font-size: 0.875rem;
            padding: 0.625rem 1.25rem;
        }
    </style>